import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';
import { Themes, useThemeName } from '@admin/shared/themes/themes';
import { AttentionIcon } from '@admin/shared/components/icons/custom/attention';

/**
 * Unauthorized Icon.
 * (used in login components)
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const UnauthorizedIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return <AttentionIcon {...props} />;
  }

  return (
    <SvgIcon name="OMQUnauthorizedIcon" {...props} viewBox="0 0 56 56">
      <path
        d="M20.183 13.58A9.288 9.288 0 0 1 28 9.333a9.33 9.33 0 0 1 9.333 9.334c0 3.266-1.68 6.16-4.246 7.816L20.183 13.58zm26.484 26.483c-.047-2.566-1.47-4.923-3.757-6.113a30.53 30.53 0 0 0-4.13-1.773l7.887 7.886zm2.776 9.38L6.557 6.557l-3.314 3.29L23.987 30.59a32.893 32.893 0 0 0-10.897 3.383c-2.333 1.19-3.757 3.594-3.757 6.207v6.487h30.73l6.09 6.09 3.29-3.314z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
